(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-type-slimbanner/assets/javascripts/banner-type-slimbanner.js') >= 0) return;  svs.modules.push('/components/content/banner-type-slimbanner/assets/javascripts/banner-type-slimbanner.js'); "use strict";


(function () {
  'use strict';

  svs.content.bannerTypeSlimbanner = {};

  svs.content.bannerTypeSlimbanner.init = function (options) {
    var $el = options.$el;
    new svs.components.ContentReveal({
      el: $el.find('.js-content-reveal-slim-banners')
    });
    $el.on('click', '.js-slim-banner', slimBannerLink);
  };

  function trackClick(el, callback) {
    var $el = $(el);
    var track = $el.data('track');
    var areaName = $el.data('areaName') || 'unknown';

    if (track) {
      svs.components.analytics.trackPromoClick({
        id: track,
        name: track,
        position: areaName
      }, callback);
    }
  }

  function slimBannerLink(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    var target = $(this).attr('target');
    trackClick(this, function () {
      if (target === '_blank') {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    });
  }
})();
 })(window);